const BASE = 'aresLoan-mbBanking.products.loansAndMortgages.productContracting.01_LoanContracting.';
const BASE_2 = 'aresLoan-mbBanking.products.loansAndMortgages.productContracting.02_LoanContracting.';

export default {
  WIZARD_NEXT_BUTTON: `${BASE}mbWizard.navigationNextButton`,
  WIZARD_ABANDON_BUTTON: `${BASE}mbWizard.navigationAbandonLink`,
  WIZARD_CONTRACT_BUTTON: `${BASE_2}mbWizard.navigationContractButton`,
  WIZARD_LEAVE_MODAL_DESCRIPTION: 'payrollLoanRequest-modalLeaveText',
  WIZARD_LEAVE_MODAL_TITLE: 'payrollLoanRequest-modalLeaveTitle',
  WIZARD_LEAVE_MODAL_LEAVE_BUTTON: 'payrollLoanRequest-modalLeaveButton',
  WIZARD_LEAVE_MODAL_CONTINUE_LATER:  'payrollLoanRequest-continueLater',
  WIZARD_OPENNING_FEE_LABEL: `${BASE}openingFeeLabelText`
};
